<template>
  <div id="cover-page">
    <div style="height: 40px;"></div>
    <div>
      <v-img :src="require('@/assets/images/cover.jpg')" height="60%" class="align-end ma-4" contain eager>
        <div class="ma-lg-16" style="background: rgba(219,219,219,0.5)">
          <p class="text-h4">Copyright East Engineering Co., Ltd.</p>
          <p class="text-h4">Drone solar plant</p>
          <p class="text-h4">thermal inspection</p>
        </div>
      </v-img>
    </div>
    <div class="d-flex justify-end">
      <div>
        <v-img :src="require('@/assets/images/logo_black.png')" width="300px" class="ma-4" eager>
        </v-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverPage",
}
</script>

<style scoped>

</style>
